import {EntityType} from "../../@types/entity";

/**
 * T is the class we want to ensure.
 *
 * @param T
 * @param item
 */
export function ensure<T extends EntityType>(T: new (...args: any[]) => T, item: any): T | null {
    if (!item) return item;
    if (item instanceof T) return item;
    else return new T({...item});
}